export default {
    message: "Gli articoli elencati di seguito sono esauriti e sono stati rimossi dal carrello. Si prega di effettuare selezioni diverse.",
    buttons: {
        ok: "OK"
    }
}